<!-- 产品信息 -->
<template>
    <div v-if="componentsData.type == 18">
        <div
            class="overflow-hidden bg-div"
            :style="
                componentsData.content.version
                    ? {
                          ...(componentsData.content.bg_color && {
                              backgroundColor: componentsData.content.bg_color,
                          }),
                          ...(componentsData.content.bg_img.picview &&
                              componentsData.content.bg_value && {
                                  backgroundImage: `url(${componentsData.content.bg_img.picview})`,
                              }),
                          padding: `${componentsData.content.paddingData.top}px ${componentsData.content.paddingData.left}px`,
                          margin: `${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px`,
                          borderRadius: `${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.top}px ${componentsData.content.radiusData.bottom}px ${componentsData.content.radiusData.bottom}px`,
                      }
                    : `padding: ${componentsData.content.marginData.top}px ${componentsData.content.marginData.left}px;background: ${componentsData.content.bg_color};border-radius: ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.topRadius}px ${componentsData.content.marginData.bottomRadius}px ${componentsData.content.marginData.bottomRadius}px`
            "
        >
            <template v-if="componentsData.content.title">
                <div
                    class="fw-bold flex-c"
                    v-if="componentsData.content.style_value == 1"
                    :style="`border-bottom: 1px solid ${componentsData.content.title_border_color};
                    background: ${componentsData.content.title_bg_color}; color: ${componentsData.content.title_color}; font-size: ${componentsData.content.title_size}px;
                `"
                >
                    <div
                        class="dec-left"
                        :style="{ background: decLeft }"
                    ></div>
                    <div class="dec-content">
                        {{ componentsData.content.title }}
                    </div>
                    <div
                        class="dec-right"
                        :style="{ background: decRight }"
                    ></div>
                </div>
                <div
                    v-else
                    class="fw-bold"
                    :style="`text-align: ${componentsData.content.position};border-bottom: 1px solid ${componentsData.content.title_border_color};
                    background: ${componentsData.content.title_bg_color}; color: ${componentsData.content.title_color}; font-size: ${componentsData.content.title_size}px;
                `"
                >
                    {{ componentsData.content.title }}
                </div>
            </template>

            <template v-if="componentsData.content.value6">
                <div class="pt-6" v-if="componentsData.content.img_value == 1">
                    <div class="img-div"></div>
                </div>
            </template>
            <div
                class="pt-6"
                :style="` color: ${componentsData.content.text_color}; font-size: ${componentsData.content.text_size}px; `"
            >
                <!-- ========== 定制模式：admin_id=1102 时显示自定义字段 ========== -->
                <template v-if="componentsData.content.custom_mode == 1">
                    <div
                        v-if="
                            componentsData.content.fields &&
                            componentsData.content.fields.order_no
                        "
                    >
                        <span class="form-label">订单编号</span>
                        <span :style="txtStyle">订单编号</span>
                    </div>
                    <div
                        v-if="
                            componentsData.content.fields &&
                            componentsData.content.fields.project_name
                        "
                    >
                        <span class="form-label">项目名称</span>
                        <span :style="txtStyle">项目名称</span>
                    </div>
                    <div
                        v-if="
                            componentsData.content.fields &&
                            componentsData.content.fields.product_name
                        "
                    >
                        <span class="form-label">产品名称</span>
                        <span :style="txtStyle">产品名称</span>
                    </div>
                    <div
                        v-if="
                            componentsData.content.fields &&
                            componentsData.content.fields.product_size
                        "
                    >
                        <span class="form-label">产品尺寸</span>
                        <span :style="txtStyle">产品尺寸</span>
                    </div>
                    <div
                        v-if="
                            componentsData.content.fields &&
                            componentsData.content.fields.product_area
                        "
                    >
                        <span class="form-label">产品面积</span>
                        <span :style="txtStyle">产品面积</span>
                    </div>
                    <div
                        v-if="
                            componentsData.content.fields &&
                            componentsData.content.fields.floor_no
                        "
                    >
                        <span class="form-label">楼层编号</span>
                        <span :style="txtStyle">楼层编号</span>
                    </div>
                    <div
                        v-if="
                            componentsData.content.fields &&
                            componentsData.content.fields.process_req
                        "
                    >
                        <span class="form-label">加工要求</span>
                        <span :style="txtStyle">加工要求</span>
                    </div>
                    <div
                        v-if="
                            componentsData.content.fields &&
                            componentsData.content.fields.factory_time
                        "
                    >
                        <span class="form-label">出厂时间</span>
                        <span :style="txtStyle">出厂时间</span>
                    </div>
                    <div
                        v-if="componentsData.content.fields"
                        class="warranty-divs"
                    >
                        <div
                            v-if="
                                componentsData.content.fields.warranty_duration
                            "
                            class="warranty-div"
                        >
                            <div class="warranty-item warranty-active">0年</div>
                            <div class="warranty-item">质保时长</div>
                        </div>
                        <div
                            v-if="
                                componentsData.content.fields.warranty_remaining
                            "
                            class="warranty-div"
                        >
                            <div class="warranty-item warranty-active">0天</div>
                            <div class="warranty-item">质保剩余时长</div>
                        </div>
                    </div>
                </template>
                <!-- ========== 原有模式 ========== -->
                <template v-else>
                    <div v-if="componentsData.content.value1">
                        产品名称:
                        <span
                            :style="`color: ${componentsData.content.txt_color}; font-size: ${componentsData.content.txt_size}px;`"
                            >产品名称</span
                        >
                    </div>
                    <div v-if="componentsData.content.value2">
                        产品规格:
                        <span
                            :style="`color: ${componentsData.content.txt_color}; font-size: ${componentsData.content.txt_size}px;`"
                            >产品规格</span
                        >
                    </div>
                    <div v-if="componentsData.content.value3">
                        产品价格:
                        <span
                            :style="`color: ${componentsData.content.txt_color}; font-size: ${componentsData.content.txt_size}px;`"
                            >产品价格</span
                        >
                    </div>
                    <div v-if="componentsData.content.value4">
                        产品分类:
                        <span
                            :style="`color: ${componentsData.content.txt_color}; font-size: ${componentsData.content.txt_size}px;`"
                            >产品分类</span
                        >
                    </div>
                    <div v-if="componentsData.content.value5">
                        产品简介:
                        <span
                            :style="`color: ${componentsData.content.txt_color}; font-size: ${componentsData.content.txt_size}px;`"
                            >产品简介</span
                        >
                    </div>
                    <div v-if="componentsData.content.value7">
                        生产时间:
                        <span
                            :style="`color: ${componentsData.content.txt_color}; font-size: ${componentsData.content.txt_size}px;`"
                            >生产时间</span
                        >
                    </div>
                    <div v-if="componentsData.content.value8">
                        过期时间:
                        <span
                            :style="`color: ${componentsData.content.txt_color}; font-size: ${componentsData.content.txt_size}px;`"
                            >过期时间</span
                        >
                    </div>
                    <div v-if="componentsData.content.value9">
                        发货时间:
                        <span
                            :style="`color: ${componentsData.content.txt_color}; font-size: ${componentsData.content.txt_size}px;`"
                            >发货时间</span
                        >
                    </div>
                </template>
            </div>
            <template v-if="componentsData.content.value6">
                <div class="pt-6" v-if="componentsData.content.img_value == 2">
                    <div class="img-div"></div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        componentsData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
    computed: {
        decLeft() {
            return `linear-gradient(to left, ${this.componentsData.content.dec_color}, transparent)`;
        },
        decRight() {
            return `linear-gradient(to right, ${this.componentsData.content.dec_color}, transparent)`;
        },
        txtStyle() {
            return `color: ${this.componentsData.content.txt_color}; font-size: ${this.componentsData.content.txt_size}px;`;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style scoped>
.overflow-hidden {
    overflow: hidden;
}
.fw-bold {
    font-weight: bold;
    padding-bottom: 6px;
}
.dec-left {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-right {
    margin: 0 12px;
    width: 50px;
    height: 4px;
    border-radius: 2px;
}
.dec-content {
    max-width: 200px;
    white-space: nowrap; /* 确保文本不会换行 */
    overflow: hidden; /* 隐藏溢出的文本 */
    text-overflow: ellipsis; /* 显示省略号来代表被修剪的文本 */
}
.img-div {
    width: 100%;
    height: 148.8px;
    background: #ccc;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.pt-6 {
    padding-top: 6px;
}
.form-label {
    display: inline-block;
    width: 111px;
}
.warranty-divs {
    margin-top: 24px;
    display: flex;
    align-content: center;
    justify-content: space-around;
}
.warranty-div {
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
}
.warranty-item {
    text-align: center;
}
.warranty-active {
    color: #ff761d !important;
    font-size: 25px !important;
}
</style>